<div class="verification-container">
    <p-card>
        <ng-template pTemplate="header">
            <div class="card-header">
                <h2>Vérification de l'e-mail</h2>
            </div>
        </ng-template>

        <div class="verification-content">
            <!-- Loading State -->
            <div *ngIf="isLoading" class="loading-state">
                <p-progressSpinner styleClass="w-4rem h-4rem"></p-progressSpinner>
                <p>Vérification de votre e-mail...</p>
            </div>

            <!-- Success State -->
            <div *ngIf="!isLoading && isSuccess && !isAlreadyConfirmed" class="success-state">
                <i class="pi pi-check-circle success-icon"></i>
                <h3>E-mail vérifié avec succès !</h3>
                <p>Votre e-mail a été confirmé. Vous pouvez maintenant accéder à toutes les fonctionnalités de votre compte.</p>
                <p-button label="Aller à la connexion" icon="pi pi-sign-in" (onClick)="navigateToLogin()"
                    styleClass="p-button-success">
                </p-button>
            </div>
            <div *ngIf="!isLoading && isSuccess && isAlreadyConfirmed" class="already-confirmed-state">
                <i class="pi pi-info-circle info-icon"></i>
                <h3>E-mail déjà vérifié</h3>
                <p>Votre e-mail a déjà été confirmé. Vous pouvez procéder à la connexion pour accéder à votre compte.</p>
                <p-button label="Aller à la connexion" icon="pi pi-sign-in" (onClick)="navigateToLogin()"
                    styleClass="p-button-info">
                </p-button>
            </div>

            <!-- Error State -->
            <div *ngIf="!isLoading && !isSuccess" class="error-state">
                <i class="pi pi-times-circle error-icon"></i>
                <h3>Échec de la vérification</h3>
                <p-message severity="error" [text]="errorMessage">
                </p-message>
                <div class="error-actions">
                    <p-button label="Renvoyer l'e-mail de vérification" icon="pi pi-refresh" (onClick)="resendVerification()"
                        styleClass="p-button-outlined">
                    </p-button>
                    <p-button label="Contact Support" icon="pi pi-envelope" (onClick)="contactSupport()"
                        styleClass="p-button-help">
                    </p-button>
                </div>
            </div>
        </div>
    </p-card>
</div>